import {Localizer} from "../../../infrastructure/localization/localizer";

export enum DashboardUddannelsesplanStatusEnum {
    Oprettet = 1,
    Klarmeldt = 2,
    Godkendt = 3,
    OverskredetFrist = 4,
    EndnuIkkeOprettet = 5
}

export function GetUddannelsesplanStatusString(status: DashboardUddannelsesplanStatusEnum): string {
    switch (status) {
        case DashboardUddannelsesplanStatusEnum.Oprettet:
            return Localizer.global_oprettet();
        case DashboardUddannelsesplanStatusEnum.Klarmeldt:
            return Localizer.global_klarmeldt();
        case DashboardUddannelsesplanStatusEnum.Godkendt:
            return Localizer.global_godkendt();
        case DashboardUddannelsesplanStatusEnum.OverskredetFrist:
            return Localizer.global_overskredetFrist();
        case DashboardUddannelsesplanStatusEnum.EndnuIkkeOprettet:
            return Localizer.global_endnuIkkeOprettet();
        default:
            return "";
    }
}
